
const ZoneTabelCodeLookup = (customParams)=>{
    return {
        valueExpr: 'Id',
        displayExpr: 'Name',
        sort: [{ selector: "Name", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '40B17B77-A2DB-4258-8F9C-84914D633FD1',
        params: {
            module: "RT",
            lookupType: "RTZoneTabelCode",
            showLookupGrid: true,
            isPascalCase: true,
            ...customParams
        },
        columns:  [
            { dataField: "Name", caption: "Code", dataType: "string" },
            { dataField: "Description", caption: "Description", dataType: "string" },
            
        ]
    }
}

export {
ZoneTabelCodeLookup
}